import React, { createContext } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App, { ToggleColorMode } from "./app/App";
import reportWebVitals from "./reportWebVitals";
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
import { BrowserRouter } from "react-router-dom";
//<div className='navbar'>
//<ResponsiveAppBar />
//</div>

export const authenticatedUser = createContext({
  name: "",
  authenticated: false,
  role: "",
});

export const AUProvider = authenticatedUser.Provider;

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ToggleColorMode />
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
